import { couponsConstants } from '@constants/coupons';
import { couponsService } from '@services';

function request() {
    return { type: couponsConstants.COUPONS_FETCH };
}

function success(data) {
    return { type: couponsConstants.COUPONS_SUCCESS, data };
}

function failure() {
    return { type: couponsConstants.COUPONS_ERROR };
}

const get = (page = 0, pageSize = 10) => {
    return dispatch => {
        dispatch(request());
        couponsService.get(page, pageSize).then(
            data => dispatch(success(data)),
            () => dispatch(failure()),
        );
    };
};

function successAll(data) {
    return { type: couponsConstants.COUPONS_SUCCESS_ALL, data };
}

function getAll() {
    return dispatch => {
        dispatch(request());
        couponsService.getAll().then(
            data => dispatch(successAll(data)),
            () => dispatch(failure()),
        );
    };
}

function setCoupons(data) {
    return { type: couponsConstants.COUPONS_SET_COUPONS, data };
}

function resetAll() {
    return { type: couponsConstants.COUPONS_RESET_ALL };
}

export const couponsActions = {
    get,
    getAll,
    setCoupons,
    resetAll,
};
